import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LabelService {

constructor(private http: HttpClient) { }

getLabels() {
  return this.http.get<any[]>(`${environment.apiUrl}labels`);
}

getLabelspage(page:any,accepted:any) {
  return this.http.get<any[]>(`${environment.apiUrl}labels?page=${page}&filter=${accepted}`);
}

ara(query:any) {
  return this.http.get<any[]>(`${environment.apiUrl}labels/search?query=${query}`);
}

getLabelbyId(id:any) {
  return this.http.get<any>(`${environment.apiUrl}labels/${id}`);
}

onayla(id:any) {
  return this.http.get<any>(`${environment.apiUrl}labels/${id}/onayla`);
}
allonayla(id:any) {
  return this.http.get<any>(`${environment.apiUrl}labels/${id}/onayla?referans=true`);
}
kaldir(id:any) {
  return this.http.get<any>(`${environment.apiUrl}labels/${id}/kaldir`);
}

allkaldir(id:any) {
  return this.http.get<any>(`${environment.apiUrl}labels/${id}/kaldir?referans=true`);
}


yeniprompt(data:any) {
  return this.http.post<any>(`${environment.apiUrl}labels/prompt`,data);
}

updateLabel(data:any,id:any,ref:boolean){
  return this.http.put<any>(`${environment.apiUrl}labels/${id}/etiket?referans=${ref}`,data);
}

updateMobil(data:any,id:any,ref:boolean){
  return this.http.put<any>(`${environment.apiUrl}labels/${id}/mobil?referans=${ref}`,data);
}
}
